import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowRotateCounterClockwise: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowRotateCounterClockwise"><Path d="M5 7.19906C6.97038 4.87491 8.95912 3.5 12.0144 3.5C16.7088 3.5 20.5144 7.30558 20.5144 12C20.5144 16.6944 16.7088 20.5 12.0144 20.5C8.31343 20.5 5.16492 18.1347 3.99805 14.8333" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/><Path d="M4.5 3.75V7.75H8.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowRotateCounterClockwise;
